import React from "react";
import { Box, Button, Icon } from "@showitinc/showit-wc";
import ActiveBlockContainerStore from "../../stores/ActiveBlockContainerStore.mjs";
import useStoreState from "../../components/providers/useStoreState";
import CreateElementMenus from "./CreateElementMenus";
import BlockUtils from "../../utils/BlockUtils";
import AppConstants from "../../constants/AppConstants";
import styles from "./Footer.module.css";
import SiteDesignStore from "../../stores/SiteDesignStore";
import UIActions from "../../actions/UIActions";

const FooterMiddleSection = () => {
  const blockContainer = useStoreState(
    ActiveBlockContainerStore,
    ActiveBlockContainerStore.getContainer
  );

  const selectedBlock = blockContainer.get("selectedBlock");
  const noBlockSelected = selectedBlock.isEmpty();
  const usingSiteBlock = BlockUtils.isUsingSiteBlock(selectedBlock);

  if (noBlockSelected)
    return <Box d="flex" align="center" className={styles.middleFooterItem}></Box>;
  if (!usingSiteBlock || !BlockUtils.hasSiteBlock(selectedBlock)) {
    return (
      <Box d="flex" align="center" className={styles.middleFooterItem}>
        <CreateElementMenus blockContainer={blockContainer} />
      </Box>
    );
  }

  const canvasSetId = selectedBlock.get("canvasSet");
  const isPageCanvasSet =
    selectedBlock.get("canvasSetPosition") !== undefined &&
    blockContainer.get("type") === AppConstants.SITE_ITEM_PAGE;

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    UIActions.itemOut();

    if (isPageCanvasSet) {
      const canvasSet = SiteDesignStore.findCanvasSet(canvasSetId);
      UIActions.selectCanvasSet({ canvasSet });
      UIActions.addActiveItemHistory({
        id: canvasSet.get("id"),
        type: AppConstants.ITEM_TYPE_CANVAS_SET,
        name: canvasSet.get("name"),
      });
    } else {
      const layout = blockContainer.get("layout");
      const baseBlock = selectedBlock.get(AppConstants.BLOCK_PROP_PARENT_BLOCK);
      UIActions.selectSiteBlock({ block: baseBlock, layout });
      UIActions.addActiveItemHistory({
        type: AppConstants.ITEM_TYPE_BLOCK,
      });
    }
  };

  return (
    <Box d="flex" align="center" className={styles.middleFooterItem}>
      <Button
        variant="feature"
        fullWidth
        onSIClick={handleClick}
        className={styles.canvasSetEditButton}
      >
        <Icon size="20" type={canvasSetId ? "canvasSet" : "siteCanvas"} />
        &nbsp; Edit {isPageCanvasSet ? "Canvas Set" : "Site Canvas"}
      </Button>
    </Box>
  );
};

export default FooterMiddleSection;
